let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lEX61")).then(() => parcelRequire('bHmzJ'));